import "pixi.js";
import BaseComponent from "./BaseComponent";
import Physics from "./Physics";
import C_GameEvent from "../const/C_GameEvent";
import ProjectileLogic from "./ProjectileLogic";

class GameSprite extends BaseComponent
{


    constructor(textureId)
    {
        super();
        this.textureId = textureId;
        this.create();
    }


    create()
    {
        this.app = PIXI.app;
        this.assets = this.app.assets;

        let texture = this.app.assets.getTexture(this.textureId);
        this.sprite = new PIXI.Sprite(texture);
        // this.aspect = texture.width / texture.height;

        this.sprite.anchor.set(.5,.5);

        this.aspect = this.sprite.width / this.sprite.height;
    }


    addAnimationSprite(endFrame, height, anchor)
    {
        this.sprite.texture = this.app.assets.getTexture(this.textureId + "_empty");

        this.animationTextures = this.app.assets.generateFrames(this.textureId + "_", 2, 0, endFrame);
        this.spriteAnimation = new PIXI.extras.AnimatedSprite(this.animationTextures);
        this.spriteAnimation.anchor.set(anchor.x, anchor.y);
        this.app.layout.propHeightScale(this.spriteAnimation, height, this.sprite);
        this.spriteAnimation.loop = true;
        this.spriteAnimation.animationSpeed = 0.3;
        this.sprite.addChildAt(this.spriteAnimation, 0);
        this.spriteAnimation.gotoAndPlay(0);
    }


    addPixelFilter()
    {
        let uniform = {angle:{type:"f", value:0}, dimensions:{type:"2fv", value:[1, 1]}};
        this.timerFilter = new PIXI.Filter(null, PIXI.loader.resources.frame_filter.data, uniform);

        this.timerFilter.apply = function(filterManager, input, output)
        {
            this.uniforms.dimensions[0] = input.sourceFrame.width;
            this.uniforms.dimensions[1] = input.sourceFrame.height;
            filterManager.applyFilter(this, input, output);
        };
        TweenMax.killTweensOf(this.timerFilter.uniforms);
        this.timerFilter.uniforms.angle =  Math.PI * 2 * (1 - Math.min(1, 1));
        TweenMax.to(this.timerFilter.uniforms, 1, {angle:Math.PI*2, ease:Linear.easeNone});
        this.sprite.filters = [this.timerFilter];
    }


    setSpriteRotation(angle)
    {
        this.sprite.rotation -= angle + Math.PI/2;
    }


    addBlinkOverlay(tweenTime)
    {
        let overlay = this.app.assets.getSprite(this.textureId + "_over");
        overlay.anchor.set(.5,.5);
        this.sprite.addChild(overlay);
        TweenMax.from(overlay, tweenTime, {alpha:0, yoyo:true, repeat:-1});
    }


    playDamageAnim()
    {
        let sprite = this.goo ?
            this.goo : this.spriteAnimation ?
            this.spriteAnimation : this.sprite;
        sprite.tint = 0xff0000;
        // TweenMax.killTweensOf(sprite);
        TweenMax.to(sprite, 0, {delay:.15, tint:0xffffff});
    }


    playDeathAnim(playExplosion)
    {
        if (playExplosion)
        {
            this.app.dispatcher.emit(C_GameEvent.FLIER_KILL, this.getEntity());
        }

        TweenMax.to(this.sprite, .2, {alpha:0});
    }


    playProjectileSplash()
    {
        let l = this.getEntity().getComponent(ProjectileLogic);
        let postfix = "";

        if (this.isBeam) // room 1
        {
            if (l.botId == 1) postfix = "_left";
            else if (l.botId == 2) postfix = "_right";

            this.sprite.texture = this.app.assets.getTexture("cockpit1_projectileSplash" + postfix);
            this.sprite.scale.x = this.sprite.scale.y;
        }
        else if (this.isElectricity) // room 2
        {
            if (l.botId == 1) postfix = "_left";
            else if (l.botId == 2) postfix = "_right";

            this.animation = false;
            let p = this.getEntity().getComponent(Physics);
            p.setSize(2.5);
            this.sprite.texture = this.app.assets.getTexture("cockpit2_projectileSplash" + postfix);
            this.sprite.scale.y = this.sprite.scale.x;
        }
        else if (this.isLaser) // room 3
        {
            if (l.botId == 1) postfix = "_left1";
            else if (l.botId == 2) postfix = "_right";

            this.sprite.texture = this.app.assets.getTexture("cockpit1_projectileSplash" + postfix);
            this.sprite.scale.x = this.sprite.scale.y;
        }

        let scale = this.sprite.scale.x * 3.5;
        TweenMax.to(this.sprite.scale, .3, {x:scale, y:scale});
        //TweenMax.to(this.sprite, .3, {rotation:this.sprite.rotation + Math.PI});
        TweenMax.to(this.sprite, .1, {alpha:0, delay:.2});
    }


    playEnemyProjectileSplash()
    {
        TweenMax.to(this.sprite, .15, {rotation:this.sprite.rotation + Math.PI});
        TweenMax.to(this.sprite, .15, {alpha:0});
    }


    playMuzzleFlash(xOffset, yOffset)
    {
        let flashSprite = new PIXI.Sprite(this.app.assets.getTexture("weapon_flash"));
        flashSprite.anchor.set(.5,.5);
        this.app.layout.propHeightScale(flashSprite, 18);
        this.sprite.addChild(flashSprite);

        flashSprite.x = this.app.layout.relWidth(xOffset, this.sprite.texture);
        flashSprite.y = this.app.layout.relHeight(yOffset, this.sprite.texture);

        let finalScale = flashSprite.scale.x * 2;

        TweenMax.from(flashSprite, .1, {alpha:0, yoyo:true, repeat:1});
        TweenMax.to(flashSprite.scale, .2, {x:finalScale, y:finalScale});
        TweenMax.to(flashSprite, .2, {rotation:Math.PI*.5});
    }


    setMultiplier()
    {
        let multCirRad = this.sprite.width*.6;
        let smallRad = this.sprite.width*.1;
        let txtSize = smallRad*2*0.8;

        this.setMultiplierRotation();

        this.multiplier = new PIXI.Graphics();
        this.multiplier.lineStyle(20, 0xffffff, 0.6);
        this.multiplier.drawCircle(0, 0, multCirRad);

        this.multiplier.lineStyle(0);
        this.multiplier.beginFill(0xff0000, 1);
        this.multiplier.drawCircle(0, -multCirRad, smallRad);
        this.multiplier.endFill();
        let x2 = this.app.assets.getTF("x2", txtSize);
        x2.anchor.set(0.5, 0.5);
        x2.y = -multCirRad;
        this.multiplier.addChild(x2);

        this.multiplier.beginFill(0x0000ff, 1);
        this.multiplier.drawCircle(multCirRad, 0, smallRad);
        this.multiplier.endFill();
        let x3 = this.app.assets.getTF("x3", txtSize);
        x3.x = multCirRad;
        x3.anchor.set(0.5, 0.5);
        this.multiplier.addChild(x3);

        this.multiplier.beginFill(0x00ff00, 1);
        this.multiplier.drawCircle(0, multCirRad, smallRad);
        this.multiplier.endFill();
        let x4 = this.app.assets.getTF("x4", txtSize);
        x4.y = multCirRad;
        x4.anchor.set(0.5, 0.5);
        this.multiplier.addChild(x4);

        this.multiplier.beginFill(0xff00ff, 1);
        this.multiplier.drawCircle(-multCirRad, 0, smallRad);
        this.multiplier.endFill();
        let x5 = this.app.assets.getTF("x5", txtSize);
        x5.x = -multCirRad;
        x5.anchor.set(0.5, 0.5);
        this.multiplier.addChild(x5);

        this.sprite.addChild(this.multiplier);

        this.playMultiplierAnimation();
    }


    playMultiplierAnimation()
    {
        TweenMax.to(this.multiplier, 20, {onUpdate:this.onMultiplierUpdate.bind(this)})
    }


    // deltaRotation - the rotation of the sprite itself if it has one set
    setMultiplierRotation(deltaRotation = 0)
    {
        this.rotationScale = 0.02 - deltaRotation;
    }


    onMultiplierUpdate()
    {
       this.multiplier.rotation += this.rotationScale;
    }


    setTarget()
    {
        this.target = this.app.assets.getSprite("target_red");
        this.target.anchor.set(.5,.5);
        this.app.layout.propHeightScale(this.target, 80, this.sprite);
        this.sprite.addChild(this.target);
        this.target.alpha = 0;
    }


    showTarget()
    {
        this.target.alpha = 1;
    }


    hideTarget()
    {
        this.target.alpha = 0;
    }


    setReticle(reticle)
    {
        this.reticle = reticle;
    }


    addAlienGoo()
    {
        this.goo = this.app.assets.getSprite("escapePodGoo");
        this.goo.anchor.set(.5,.5);
        this.app.layout.propHeightScale(this.goo, 100, this.sprite);
        this.sprite.addChild(this.goo);
        this.goo.alpha = 1;
    }


    hasGoo()
    {
        if (this.goo != undefined)
            return true;
        else
            return false;
    }


    // TODO destroy animation for the alein goo?
    hideGoo()
    {
        this.goo.alpha = 0;
    }


    playGooKillAnim()
    {
        this.stopUpdate = true;
        this.hideGoo();
    }


    init()
    {
        super.init();
        TweenMax.from(this.sprite, this.fadeInTime, {alpha:0});
    }


    setSize(val)
    {
        this.size = val;
    }


    postPhysicsUpdate(delta)
    {
        if (this.stopUpdate)
        {
            return;
        }

        let p = this.entity.getComponent(Physics);

        p.setSpriteRendered(true);

        if (this.size)
        {
            p.setSize(this.size * (p.position.z * 0.05));
        }

        let projected = this.app.layout.projectGameToScreen(p.position, p.getSize());

        this.sprite.x = projected.x;
        this.sprite.y = projected.y;
        this.sprite.sortZ = (p.position.z * 1000);

        this.sprite.height = projected.z;
        this.sprite.width = projected.z * this.aspect;

        if (this.animation)
        {
            this.animTimer += delta;
            if (this.animTimer >= this.frameTime)
            {
                this.animTimer = 0;
                this.animCounter ++;
                this.animCounter %= this.numFrames;
                this.updateAnimationTexture();
            }
        }

        this.updateReticlePosition();
    }


    updateReticlePosition()
    {
        if (this.reticle)
        {
            let mv = this.entitySystem.mainView;
            let mc = mv.mainContainer;

            let pos = mv.toLocal(mc.toGlobal(new PIXI.Point(this.sprite.x, this.sprite.y)));
            this.reticle.x = pos.x;
            this.reticle.y = pos.y;
        }
    }


    setupAnimation(animPrefix, fps, numFrames)
    {
        this.animation = true;
        this.animPrefix = animPrefix;
        this.animCounter = 0;
        this.frameTime = 1/fps;
        this.animTimer = 0;
        this.numFrames = numFrames;
        this.updateAnimationTexture();
    }


    updateAnimationTexture()
    {
        this.sprite.texture = this.assets.getTexture(this.animPrefix + this.animCounter);
    }


    destroy()
    {
        TweenMax.killTweensOf(this.sprite);
        TweenMax.killTweensOf(this.multiplier);
        super.destroy();
    }


    scaleAspect(scale)
    {
        this.sprite.height *= scale;
        this.aspect = this.sprite.width / this.sprite.height;
        // this.aspect *= scale;

        //this.aspect = this.sprite.width / this.sprite.height;
    }

    debugAspect()
    {
        console.log(this.aspect);
    }
}


export default GameSprite